import { createContext, useContext, useEffect, useMemo } from "react";
import { useAuthState } from "../hooks/useAuthState";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking, false = anonymous, object = logged in
    const { state, setUser, checkAuth, login, register, logout } = useAuthState();

    useEffect(() => {
        // If returning from OAuth callback, AuthCallback handles it - skip /me
        if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const value = useMemo(
        () => ({ user: state.user, setUser, error: state.error, login, register, logout, refresh: checkAuth }),
        [state.user, state.error, setUser, login, register, logout, checkAuth]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
